import { __assign, __read, __rest } from "tslib";
import React, { useContext, useImperativeHandle, forwardRef, useMemo, } from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { Icon } from "../icon";
import { useDefault } from "../_util/use-default";
import { callBoth } from "../_util/call-both";
import { TaroEnv } from "../_util/env";
import { useConfig } from "../_util/use-config";
/**
 * Check 组件支持使用 CheckContext 进行状态托管
 */
export var CheckContext = React.createContext(null);
var DEFAULT_COLOR = "#006EFF";
export var Check = forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.color, color = _d === void 0 ? DEFAULT_COLOR : _d, restProps = __rest(_a, ["color"]);
    var classPrefix = useConfig().classPrefix;
    // 支持从 Context 注入
    var context = useContext(CheckContext);
    var props = restProps;
    if (context) {
        props = context.inject(restProps);
    }
    var _e = props.defaultChecked, defaultChecked = _e === void 0 ? false : _e, checked = props.checked, onCheckedChange = props.onChange, radio = props.radio, children = props.children, _f = props.disabled, disabled = _f === void 0 ? false : _f, block = props.block, type = props.type, onClick = props.onClick, className = props.className, style = props.style, htmlProps = __rest(props, ["defaultChecked", "checked", "onChange", "radio", "children", "disabled", "block", "type", "onClick", "className", "style"]);
    var _g = __read(useDefault(checked, defaultChecked, onCheckedChange), 2), value = _g[0], onChange = _g[1];
    useImperativeHandle(ref, function () { return ({
        trigger: function (event) {
            if (disabled) {
                return;
            }
            onChange(!value, { event: event });
        },
    }); }, [onChange, value, disabled]);
    var iconSize = useMemo(function () {
        if (type === "agreement") {
            return TaroEnv ? 32 : 16;
        }
        return TaroEnv ? 40 : 20;
    }, [type]);
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-checkbox-wrap", className, (_b = {
                "is-checked": value,
                "is-disabled": disabled
            },
            _b[classPrefix + "-checkbox__wrap--block"] = block,
            _b[classPrefix + "-checkbox__wrap--agreement"] = type === "agreement",
            _b[classPrefix + "-checkbox__wrap--outline"] = type === "button",
            _b)), style: style, onClick: callBoth(onClick, function (event) {
            event.stopPropagation();
            if (disabled) {
                return;
            }
            onChange(!value, { event: event });
        }) }, htmlProps),
        type !== "button" && (React.createElement(View, { className: classNames(classPrefix + "-checkbox", (_c = {},
                _c[classPrefix + "-checkbox--square"] = type === "square" || type === "agreement",
                _c)) }, value && React.createElement(Icon, { name: "check", color: "#fff", size: iconSize }))),
        React.createElement(View, { className: classPrefix + "-checkbox__label" }, children)));
});
//# sourceMappingURL=Check.js.map